import { render, staticRenderFns } from "./EcommTestimonials.vue?vue&type=template&id=31e7f72d&scoped=true"
import script from "./EcommTestimonials.vue?vue&type=script&lang=js"
export * from "./EcommTestimonials.vue?vue&type=script&lang=js"
import style0 from "./EcommTestimonials.vue?vue&type=style&index=0&id=31e7f72d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7f72d",
  null
  
)

export default component.exports